const millisecondsInMin = 60_000;

export const isCancellationExpired = (startAt: string, minutes: number): boolean => {
  if (minutes == null || startAt == null) {
    return false;
  }

  if (new Date().getTime() > new Date(startAt).getTime()) {
    return true;
  }

  const limitTime = new Date(new Date(startAt).getTime() - minutes * millisecondsInMin);

  return new Date().getTime() > new Date(limitTime).getTime();
};
